// extracted by mini-css-extract-plugin
export default {"root":"Footer__root--rzXXN","agents":"Footer__agents--kcXTC"};